import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { PeopleForm } from '@/features/featured-people/components/PeopleForm';
import { usePeopleFormPicker } from '@/features/featured-people/hooks/use-people-form-picker';
import { TFeaturedPeopleForm } from '@/features/featured-people/types';
import { getAbsoluteDateFromPlayerTime } from '@/utils/hh-mm-ss-into-number';

import { useClipToolkitPeopleFormState } from '../hooks/useClipToolkitPeopleFormState';

export function ClipToolkitPeopleForm() {
  const { activeClip, playerVideoCurrentTime, handleDateTimeClip, personaClipData, formBox } =
    useBroadcastScheduleProgram();
  const {
    form,
    isCreatingPeople,
    peopleDrawer,
    handleSubmitPeople,
    renderAdditionalButtons,
    handleClickExit,
    handleSubmit,
  } = useClipToolkitPeopleFormState();

  const { picker, selectedPerson, selectCreatedPerson } = usePeopleFormPicker({
    form,
    fallbackLabel: personaClipData?.entity_label,
    syncLabel: formBox === 'people',
  });

  const handleClickAdd = () => {
    if (!activeClip?.start_datetime) return;

    const newDateTime = getAbsoluteDateFromPlayerTime(
      activeClip.start_datetime,
      playerVideoCurrentTime
    );

    form.setValue('start_datetime', newDateTime);
    form.setValue('end_datetime', newDateTime);
  };

  const handleCreatePerson = async (data: TFeaturedPeopleForm) => {
    const person = await handleSubmitPeople(data);
    selectCreatedPerson(person);
    return person;
  };

  return (
    <PeopleForm
      form={form}
      peoplePicker={picker}
      selectedPeople={selectedPerson}
      isCreatingPeople={isCreatingPeople}
      peopleDrawer={peopleDrawer}
      handleClickAdd={handleClickAdd}
      handleClickExit={handleClickExit}
      handleSubmit={handleSubmit}
      handleSubmitPeople={handleCreatePerson}
      renderAdditionalButtons={renderAdditionalButtons}
      onClickTooltipDate={name => handleDateTimeClip(form, name)}
    />
  );
}
